import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { getStripe, getStripeEnvironment } from "@/lib/stripe";
import { createStayCheckoutSession } from "@/lib/stay-payment.functions";

interface Props {
  email: string;
  code: string;
  returnUrl: string;
}

/** Card form for paying a confirmed stay — rooms, boats and extras together. */
export function StayEmbeddedCheckout({ email, code, returnUrl }: Props) {
  const fetchClientSecret = async (): Promise<string> => {
    const result = await createStayCheckoutSession({
      data: { email, code, returnUrl, environment: getStripeEnvironment() },
    });
    if ("error" in result) throw new Error(result.error);
    if (!result.clientSecret) throw new Error("Payment could not be started.");
    return result.clientSecret;
  };

  return (
    <div id="stay-checkout">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={{ fetchClientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
